"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Component;
}(vue_1.default));
exports.Component = Component;
/**
 * Create component from component options (Compatible with Vue.extend)
 */
function createComponent(opts) {
    return vue_1.default.extend(opts);
}
exports.createComponent = createComponent;
var factoryImpl = {
    convert: function (c) { return c; },
    extendFrom: function (c) { return c; }
};
/**
 * Specify Props and Event types of component
 *
 * Usage:
 *  // Get TSX-supported component with props(`name`, `value`) and event(`onInput`)
 *  const NewComponent = tsx.ofType<{ name: string, value: string }, { onInput: string }>.convert(Component);
 */
function ofType() {
    return factoryImpl;
}
exports.ofType = ofType;
function withNativeOn(componentType) {
    return componentType;
}
exports.withNativeOn = withNativeOn;
function withHtmlAttrs(componentType) {
    return componentType;
}
exports.withHtmlAttrs = withHtmlAttrs;
function withUnknownProps(componentType) {
    return componentType;
}
exports.withUnknownProps = withUnknownProps;
function withPropsObject(componentType) {
    return componentType;
}
exports.withPropsObject = withPropsObject;
function createComponentFactory(base, mixins) {
    return {
        create: function (options) {
            var mergedMixins = options.mixins ? __spreadArrays(options.mixins, mixins) : mixins;
            return base.extend(__assign(__assign({}, options), { mixins: mergedMixins }));
        },
        mixin: function (mixinObject) {
            return createComponentFactory(base, __spreadArrays(mixins, [mixinObject]));
        }
    };
}
function createExtendableComponentFactory() {
    return {
        create: function (options) {
            return vue_1.default.extend(options);
        },
        extendFrom: function (base) {
            return createComponentFactory(base, []);
        },
        mixin: function (mixinObject) {
            return createComponentFactory(vue_1.default, [mixinObject]);
        }
    };
}
exports.componentFactory = createExtendableComponentFactory();
function componentFactoryOf() {
    return exports.componentFactory;
}
exports.componentFactoryOf = componentFactoryOf;
/**
 * Shorthand of `componentFactory.create`
 */
exports.component = exports.componentFactory.create;
exports.extendFrom = exports.componentFactory.extendFrom;
function emit(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, __spreadArrays([name], args));
}
exports.emit = emit;
function emitOn(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, __spreadArrays([name.replace(/^on[A-Z]/, function (v) { return v[2].toLowerCase(); })], args));
}
exports.emitOn = emitOn;
function emitUpdate(vm, name, value) {
    vm.$emit("update:" + name, value);
}
exports.emitUpdate = emitUpdate;
//# sourceMappingURL=data:application/json;base64,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